/**
 * @copyright @ 2021 Cognition Solutions. All rights reserved.
 * @description Reducer for Reset Password page.
 * --------------------------------------------------------------------
 * Creation Details
 * @author Nithin Kumar
 * Date Created  : 18/Aug/2022
 * FDO Ref:
 * TDO Ref:
 * RTM Ref:
 * Test Case Ref:
 */

// ----------------------------------------------------------------------

/* Imports */
import {
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_RESET,
  RESET_PASSWORD_SUCCESS,
} from "../../actions";

// ----------------------------------------------------------------------

/** Initial State */
const resetPasswordInitialState = {
  loading: false,
  success: null,
  failure: null,
};

/**
 * Reducer method for particular action
 * @param {*} state initial state
 * @param {*} action particular action
 * @returns updated state
 */
export const resetPassword = (
  state = resetPasswordInitialState,
  action = {}
) => {
  switch (action.type) {
    case RESET_PASSWORD_REQUEST:
      return { ...state, loading: true };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
        failure: null,
      };
    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        success: null,
        failure: action.payload,
      };
    case RESET_PASSWORD_RESET:
      return {
        ...state,
        loading: false,
        success: null,
        failure: null,
      };
    default:
      return state;
  }
};
